import React from 'react'
import { Post } from '@/payload-types'
import { GridBlock } from '@/components'

interface PostListProps {
  items: Post[]
}

function PostList({ items }: Readonly<PostListProps>) {
  if (items.length === 0) return null

  return (
    <GridBlock
      blockType="grid"
      items={items.map((post) => ({
        relationTo: 'posts' as const,
        value: post,
      }))}
    />
  )
}

export { PostList }
